import {
  BOOKS_PENDING,
  BOOKS_DOWNLOADED,
  BOOKS_FAILED, BOOK_REMOVED, BOOK_SENDING,
} from './types';
import BooksApiService from '../../services/api/BooksApiService';
import { handleError } from '../infos/actions';

export const booksDownloadedAction = (books) => ({
  type: BOOKS_DOWNLOADED,
  payload: books,
});

export const booksFailedAction = (error) => ({
  type: BOOKS_FAILED,
  payload: error,
});

export const booksPendingAction = () => ({
  type: BOOKS_PENDING,
});

export const bookRemovedAction = (book) => ({
  type: BOOK_REMOVED,
  payload: book,
});

export const bookSendingAction = () => ({
  type: BOOK_SENDING,
});

export function getBooks(authUserToken, role) {
  return (dispatch) => {
    dispatch(booksPendingAction());
    return BooksApiService
      .getBooks(authUserToken, role)
      .then((data) => {
        dispatch(booksDownloadedAction(data));
        return data;
      })
      .catch((error) => {
        dispatch(booksFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function deleteBook(authUserToken, bookId, role) {
  return (dispatch) => {
    dispatch(bookSendingAction());
    return BooksApiService
      .deleteBook(authUserToken, bookId, role)
      .then(() => {
        dispatch(bookRemovedAction(bookId));
        return null;
      })
      .catch((error) => {
        dispatch(booksDownloadedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/books/actions.js